import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "quoteleft" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Checkout", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Your Information", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "fieldleft" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_11 = { class: "fieldright" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_13 = { class: "fieldleft" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_15 = { class: "fieldright" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_17 = ["max"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_19 = { class: "field" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "emaildocs" }, " I'd like to receieve my Renters Insurance policy and billing documents by email. ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Additional Parties - No Additional Cost", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","line-height":"22px"} }, " Only applicable for Renters Insurance policy. ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "additional-table"
}
const _hoisted_33 = {
  valign: "top",
  width: "75%"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  id: "roommate",
  onclick: "document.getElementById('roommate-content').classList.toggle('show');document.getElementById('roommate').classList.toggle('checked');"
}, "Roommate ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  id: "roommate-content",
  class: "additional-content",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createTextVNode(" You can add one roommate to your policy. (Your spouse, domestic partner or dependent are automatically covered and don't need to be added)."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Have more than one roommate? No worries, just have them purchase another policy from us. ")
], -1)
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  width: "100",
  style: {"text-align":"right"}
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "add-roommate-2" }, null, -1)
const _hoisted_40 = {
  valign: "top",
  width: "75%"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", {
  id: "roommate",
  onclick: "document.getElementById('interestedparty-content').classList.toggle('show');document.getElementById('interestedparty').classList.toggle('checked');"
}, "Interested Party", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  id: "interestedparty-content",
  class: "additional-content",
  style: {"display":"none"}
}, " This is typically your landlord or property manager. Put down their information and we'll automatically notify them that you've got coverage. ", -1)
const _hoisted_43 = {
  width: "100",
  style: {"text-align":"right"}
}
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "3" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div style=\"clear:both;\"></div><div class=\"spacer\"></div><hr><div class=\"spacer\"></div><div class=\"subtitle\">Property Address</div><br><br><div style=\"clear:both;\"></div>", 8)
const _hoisted_54 = { style: {"font-size":"20px"} }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mailing Address")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "usesameadddress" }, " Use same address as above ", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "fieldleft" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_62 = { class: "fieldright" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, "Apt/Suite", -1)
const _hoisted_64 = { class: "fieldleft" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_66 = { class: "fieldright" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_68 = { class: "fieldleft" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  id: "payment",
  class: "spacer"
}, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "School Information", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = { class: "fieldleft" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "Please Select...", -1)
const _hoisted_79 = { class: "fieldleft" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_81 = ["disabled"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "Please Select...", -1)
const _hoisted_83 = ["value"]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_87 = {
  ref: "payment",
  class: "subtitle"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("p", null, " Your one-time payment will be processed today, even if your policy is effective later. We'll then automatically charge your recurring payments. ", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", {
  for: "creditcard",
  style: {"font-size":"16px"}
}, " Credit / Debit Card ", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_92 = { key: 2 }
const _hoisted_93 = { class: "field" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_96 = { class: "fieldleft" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_98 = { class: "fieldright" }
const _hoisted_99 = ["src"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_101 = { class: "fieldleft" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("hint", { style: {"font-size":"12px"} }, " This is the 3 or 4 digit number on the back of the card. ", -1)
const _hoisted_104 = { class: "fieldright" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_106 = { style: {"width":"40%","float":"left","margin-right":"1%"} }
const _hoisted_107 = ["value"]
const _hoisted_108 = { style: {"width":"50%","float":"left"} }
const _hoisted_109 = ["value"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_113 = { class: "paymentplannotice" }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_117 = { key: 1 }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Billing Address")
], -1)
const _hoisted_122 = { class: "billingaddress-radios" }
const _hoisted_123 = { for: "billingaddress-property" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_125 = { for: "billingaddress-mailing" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { for: "billingaddress-different" }, "Use different billing address", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_129 = { key: 3 }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_131 = { class: "fieldleft" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_133 = { class: "fieldright" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_135 = { class: "fieldleft" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_137 = { class: "fieldright" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", { class: "tinylabel" }, "Apt/Suite", -1)
const _hoisted_139 = { class: "fieldleft" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_141 = { class: "fieldright" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_143 = { class: "fieldleft" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_148 = { style: {"text-align":"center"} }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import ElectronicConsentModal from "@/views/modals/context/ElectronicConsentModal.vue";
import MessageServiceModal from "@/views/modals/context/MessageServiceModal.vue";
import AddUserModal from "@/views/modals/context/AddUserModal.vue";
import AddInterestedPartyModal from "@/views/modals/context/AddInterestedPartyModal.vue";
import QuoteCart from "@/views/quote/QuoteCart.vue";
import UsStatesBox from "@/components/UsStatesBox.vue";
import { InsuranceUser } from "@/models/InsuranceUser";
import { InterestedParty } from "@/models/InterestedParty";
import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { BillingAddressType } from "@/models/PaymentMethod";
import {
  formatDateForDateInput,
  formatAddress,
  formatAmount,
  calculateQuoteNssi,
  scrollTop,
  scrollMeTo,
  minus18YearsDate,
  stat,
} from "@/utils/Utils";
import StatusComponent from "@/components/StatusComponent.vue";
import { PaymentOptions } from "@/models/QuoteInsurance";
import { DateTimeFormatter, LocalDate } from "@js-joda/core";
import ValidationError from "@/components/ValidationError.vue";
import { validateCard, validateCVV } from "@/utils/CreditCards";
import { onMounted, ref, computed, Ref, ComputedRef, watch } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import { useStatusStore } from "@/stores/root/status";
import useModal from "@/hooks/useModal";
import Modals from "@/utils/Modals";
import BaseModal from "@/views/modals/BaseModal.vue";
import { UserData } from "@/api/UserData";

const title = "Checkout";

export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteCheckout',
  props: {
  anchor: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const loading: Ref<boolean> = ref(false);
//const intrestedShow: Ref<boolean> = ref(true);
const nssiSchoolCities: Ref<any[]> = ref([]);
const nssiSchoolsByCity: Ref<any[]> = ref([]);
const phoneRaw = ref("");
const hasRoomate = ref(false);
const hasInterestedParty = ref(false);
const validationErrors: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const electronicConsentModal = ref();
const messageServiceModal = ref();
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;
const { toggleModal } = useModal();
const schoolDisabled = ref();

const readNssiSchoolsCities = async () => {
  nssiSchoolCities.value = [];
  nssiSchoolsByCity.value = [];
  const citiesResult = await NssiData.getCities(quote);
  if (citiesResult.error) {
    stat(statusStore).error(citiesResult.message);
    scrollMeTo("status");
  } else {
    nssiSchoolCities.value = [];
    nssiSchoolsByCity.value = [];
    //TODO refactor for loop why?
    nssiSchoolCities.value = citiesResult.result.ObjectList;
    // citiesResult.result.ObjectList.forEach((element: any) => {
    //   const city = {
    //     key: element.Key,
    //     value: element.Value,
    //   };
    //   nssiSchoolCities.value.push(city);
    // });
  }
};

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  clearValidationMessage(event.target.name);
}

const readNssiSchools = async (event: any = null) => {
  loading.value = true;
  nssiSchoolsByCity.value = [];

  const result = await NssiData.getSchoolsByCity(quote);
  if (result.error) {
    stat(statusStore).error(result.message);
    scrollMeTo("status");
  } else {
    nssiSchoolsByCity.value = [];
    //TODO refactor for loop why?
    nssiSchoolsByCity.value = result.result.ObjectList;
    // result.result.ObjectList.forEach((element: any) => {
    //   const school = {
    //     key: element.Key,
    //     value: element.Value,
    //   };
    //   nssiSchoolsByCity.value.push(school);
    // });
  }
  loading.value = false;
  if (event) {
    validatedFieldChanged(event);
  }
};
//TODO user why
watch([quote, user], (current) => {
  if (current[0].checkout.interestedParty.firstName.length > 0) {
    hasInterestedParty.value = true;
  }
  if (current[0].checkout.roommates.length > 0) {
    hasRoomate.value = true;
  }
  if (!current[1].loggedIn) {
    quote.setQuoteStep("quote-account");
  }
  current[0].checkout.schoolCity.length > 0
    ? (schoolDisabled.value = false)
    : (schoolDisabled.value = true);
});

onMounted(async () => {
  if (!user.loggedIn) {
    quote.setQuoteStep("quote-account");
  }
  quote.checkout.schoolCity.length > 0
    ? (schoolDisabled.value = false)
    : (schoolDisabled.value = true);
  if (props.anchor) {
    scrollMeTo(props.anchor);
  }
  loading.value = true;
  if (
    user &&
    user.loggedIn &&
    user.firstName &&
    !quote.checkout.info.firstName
  ) {
    quote.checkout.info.firstName = user.firstName;
  }
  if (user && user.loggedIn && user.lastName && !quote.checkout.info.lastName) {
    quote.checkout.info.lastName = user.lastName;
  }
  await readNssiSchoolsCities();
  if (quote.checkout.schoolCity) {
    await readNssiSchools();
  }
  hasRoomate.value = quote.checkout.roommates.length > 0;
  hasInterestedParty.value = quote.checkout.interestedParty.firstName != "";
  loading.value = false;
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (!quote.checkout.info.firstName) {
    const error = {
      name: "firstName",
      value: "First name is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.checkout.info.lastName) {
    const error = {
      name: "lastName",
      value: "Last name is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.checkout.info.phone) {
    const error = {
      name: "phone",
      value: "Phone number is required.",
    };
    validationErrors.value.push(error);
  }
  if (!quote.checkout.info.dob) {
    const error = {
      name: "dob",
      value: "Date of birth is required.",
    };
    validationErrors.value.push(error);
  } else {
    if (
      +new Date(quote.checkout.info.dob).setHours(0, 0, 0, 0) >
      +new Date(minus18YearsDate.value).setHours(0, 0, 0, 0)
    ) {
      const error = {
        name: "dob",
        value: "Must be 18 years or older.",
      };
      validationErrors.value.push(error);
    }
  }
  if (!quote.checkout.info.email) {
    const error = {
      name: "email",
      value: "Email is required.",
    };
    validationErrors.value.push(error);
  }

  if (!quote.checkout.useSameAddressForMailing) {
    if (!quote.checkout.mailingAddress.address) {
      const error = {
        name: "mailingAddress",
        value: "Address is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.mailingAddress.city) {
      const error = {
        name: "mailingCity",
        value: "City is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.mailingAddress.state.short) {
      const error = {
        name: "mailingState",
        value: "State is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.mailingAddress.zip) {
      const error = {
        name: "mailingZip",
        value: "Zip code is required.",
      };
      validationErrors.value.push(error);
    }
  } // useSameAddressForMailing
  if (quote.hasPersonalInsurance) {
    if (!quote.checkout.schoolCity) {
      const error = {
        name: "schoolCity",
        value: "School city is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.schoolKey) {
      const error = {
        name: "schoolName",
        value: "School name is required.",
      };
      validationErrors.value.push(error);
    }
  } // hasPersonalInsurance
  if (quote.checkout.paymentMethod.creditCard) {
    let creditCardValidated = false;
    if (!quote.checkout.paymentMethod.nameOnCard) {
      const error = {
        name: "nameOnCard",
        value: "Name on card is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.cardNumber) {
      const error = {
        name: "cardNumber",
        value: "Card number is required.",
      };
      validationErrors.value.push(error);
    } else {
      creditCardValidated = validateCard(
        quote.checkout.paymentMethod.cardNumber
      );
      if (!creditCardValidated) {
        const error = {
          name: "cardNumber",
          value:
            "Entered card is not supported. We support Master card, Visa, American Express and Discover.",
        };
        validationErrors.value.push(error);
      }
    }
    if (!quote.checkout.paymentMethod.cvv) {
      const error = {
        name: "cvv",
        value: "CVC is required.",
      };
      validationErrors.value.push(error);
    } else if (creditCardValidated) {
      if (
        !validateCVV(
          quote.checkout.paymentMethod.cardNumber,
          quote.checkout.paymentMethod.cvv
        )
      ) {
        const error = {
          name: "cvv",
          value: "Invalid CVC number.",
        };
        validationErrors.value.push(error);
      }
    }
    if (!quote.checkout.paymentMethod.expDateMonth) {
      const error = {
        name: "expDateMonth",
        value: "Month is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.expDateYear) {
      const error = {
        name: "expDateYear",
        value: "Year is required.",
      };
      validationErrors.value.push(error);
    }
  } // credit card
  if (
    quote.checkout.paymentMethod.billingAddressType ==
    BillingAddressType.Different
  ) {
    if (!quote.checkout.paymentMethod.billingAddress.firstName) {
      const error = {
        name: "billingFirstName",
        value: "First name is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.lastName) {
      const error = {
        name: "billingLastName",
        value: "Last name is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.address) {
      const error = {
        name: "billingAddress",
        value: "Address is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.city) {
      const error = {
        name: "billingCity",
        value: "City is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.state.short) {
      const error = {
        name: "billingState",
        value: "State is required.",
      };
      validationErrors.value.push(error);
    }
    if (!quote.checkout.paymentMethod.billingAddress.zip) {
      const error = {
        name: "billingZip",
        value: "Zip code is required.",
      };
      validationErrors.value.push(error);
    }
  } //billingAddress
} // createValidationMessages

const validated = computed(() => {
  let result = true;
  const infoValidated =
    quote.checkout.info.firstName &&
    quote.checkout.info.lastName &&
    quote.checkout.info.phone &&
    quote.checkout.info.dob &&
    quote.checkout.info.email;
  result = result && Boolean(infoValidated);
  if (result) {
    if (
      +new Date(quote.checkout.info.dob).setHours(0, 0, 0, 0) >
      +new Date(minus18YearsDate.value).setHours(0, 0, 0, 0)
    ) {
      result = false;
    }
  }
  if (!result) {
    return false;
  }
  if (!quote.checkout.useSameAddressForMailing) {
    const mailAddressValidated =
      quote.checkout.mailingAddress.address &&
      quote.checkout.mailingAddress.city &&
      quote.checkout.mailingAddress.state.short &&
      quote.checkout.mailingAddress.zip;
    result = result && Boolean(mailAddressValidated);
  }
  if (!result) {
    return false;
  }
  if (quote.hasPersonalInsurance) {
    result =
      result &&
      Boolean(quote.checkout.schoolCity) &&
      Boolean(quote.checkout.schoolKey);
  }
  if (!result) {
    return false;
  }
  if (quote.checkout.paymentMethod.creditCard) {
    const crediCardValidated =
      Boolean(quote.checkout.paymentMethod.nameOnCard) &&
      Boolean(quote.checkout.paymentMethod.cardNumber) &&
      Boolean(quote.checkout.paymentMethod.cvv) &&
      Boolean(quote.checkout.paymentMethod.expDateMonth) &&
      Boolean(quote.checkout.paymentMethod.expDateYear);
    result = result && crediCardValidated;
    if (result) {
      const creditCardValidated = validateCard(
        quote.checkout.paymentMethod.cardNumber
      );
      if (!creditCardValidated) {
        return false;
      }
      result =
        result &&
        validateCVV(
          quote.checkout.paymentMethod.cardNumber,
          quote.checkout.paymentMethod.cvv
        );
    }
  }
  if (!result) {
    return false;
  }
  if (
    quote.checkout.paymentMethod.billingAddressType ==
    BillingAddressType.Different
  ) {
    const billAddressValidated =
      quote.checkout.paymentMethod.billingAddress.firstName &&
      quote.checkout.paymentMethod.billingAddress.lastName &&
      quote.checkout.paymentMethod.billingAddress.address &&
      quote.checkout.paymentMethod.billingAddress.city &&
      quote.checkout.paymentMethod.billingAddress.state.short &&
      quote.checkout.paymentMethod.billingAddress.zip;
    result = result && Boolean(billAddressValidated);
  }
  return result;
});

function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollTop();
    return;
  }
  quote.checkout.info.phone = phoneRaw.value;
  const schoolKey = quote.checkout.schoolKey;
  const selectedSchool = nssiSchoolsByCity.value.filter((school) => {
    if (school.Key == schoolKey) return school.Value;
  });
  if (schoolKey) {
    quote.checkout.schoolName = selectedSchool[0].Value;
  }
  quote.setQuoteStep(command);
}

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

function showConsentModal() {
  toggleModal(Modals.ELECTRONIC_CONSENT_MODAL.label);
}

/**
 * Shows modal to add new user
 */
function showAddRoomateModal() {
  hasRoomate.value = false;
  toggleModal(Modals.ADD_USER_MODAL.label);
}

/**
 * Shows modal to add new party user
 */
function showInterestedPartyModal() {
  hasInterestedParty.value = false;
  toggleModal(Modals.ADD_INTERESTED_PARTY.label);
}

/**
 * User (roommate or authorized) has been added from the modal
 */
function onUserAdded() {
  hasRoomate.value = true;
}

/**
 * Remove roommate from list of quote roommates
 */
function removeRoommate(roommate: InsuranceUser) {
  const index = quote.checkout.roommates.indexOf(roommate);
  if (index > -1) {
    quote.checkout.roommates.splice(index, 1);
  }
  hasRoomate.value = quote.checkout.roommates.length > 0;
}
/**
 * Interested party has been added from the modal
 */
function onInterestedPartyAdded() {
  hasInterestedParty.value = true;
}
/**
 * Removes interested party from list of quote interested parties
 */
function removeInterestedParty(party: InterestedParty) {
  quote.checkout.interestedParty = new InterestedParty();
  hasInterestedParty.value = false;
}

const cardYears: ComputedRef<string[]> = computed(() => {
  const result = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i < currentYear + 20; i++) {
    result.push(i.toString());
  }
  return result;
});

function pad(num: number, size: number) {
  let res = num.toString();
  while (res.length < size) res = "0" + num;
  return res;
}

const cardMonths: ComputedRef<string[]> = computed(() => {
  const result = [];
  for (let i = 1; i <= 12; i++) {
    result.push(pad(i, 2));
  }
  return result;
});

const mailingAddress: ComputedRef<string> = computed(() => {
  if (quote.checkout.useSameAddressForMailing) {
    return quote.address.formatted;
  } else {
    return formatAddress(quote.checkout.mailingAddress);
  }
});

const rentersNextPayment: ComputedRef<string> = computed(() => {
  let date = undefined;
  if (quote.rentersInsurance.paymentOption == PaymentOptions.Annual) {
    return "";
  } else if (quote.rentersInsurance.paymentOption == PaymentOptions.FourPay) {
    date = LocalDate.now().plusMonths(4);
  } else if (quote.rentersInsurance.paymentOption == PaymentOptions.Monthly) {
    date = LocalDate.now().plusMonths(1);
  }
  const amtFormatted = formatAmount(
    quote.rentersInsurance.installmentAmount + quote.rentersInsurance.serviceFee
  );
  const dateFormatted = date?.format(DateTimeFormatter.ofPattern("M/d/yyyy"));
  return `Your next payment for your Renters Insurance (${amtFormatted}) will be automatically charged on ${dateFormatted}.`;
});

const nssiNextPayment: ComputedRef<string> = computed(() => {
  if (!quote.hasPersonalInsurance) {
    return "";
  }
  if (quote.personalInsurance.paymentOption == PaymentOptions.Annual) {
    return "";
  } else if (quote.personalInsurance.paymentOption == PaymentOptions.Monthly) {
    const date = LocalDate.now().plusMonths(1);
    const amtFormatted = formatAmount(calculateQuoteNssi(quote));
    const dateFormatted = date?.format(DateTimeFormatter.ofPattern("M/d/yyyy"));
    return `Your next payment for your Accidental Damage Personal Property Insurance (${amtFormatted}) will be automatically charged on ${dateFormatted}.`;
  }
  return "";
});

return (_ctx: any,_cache: any) => {
  const _component_hint = _resolveComponent("hint")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(StatusComponent),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('firstName') }])
          }, [
            _createTextVNode("First Name "),
            _hoisted_10
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(quote).checkout.info.firstName) = $event)),
            type: "text",
            name: "firstName",
            class: _normalizeClass({ validationfield: hasErrors('firstName') }),
            onInput: validatedFieldChanged
          }, null, 34), [
            [_vModelText, _unref(quote).checkout.info.firstName]
          ]),
          _createVNode(ValidationError, {
            name: "firstName",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('lastName') }])
          }, [
            _createTextVNode("Last Name "),
            _hoisted_12
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(quote).checkout.info.lastName) = $event)),
            type: "text",
            name: "lastName",
            class: _normalizeClass({ validationfield: hasErrors('lastName') }),
            onInput: validatedFieldChanged
          }, null, 34), [
            [_vModelText, _unref(quote).checkout.info.lastName]
          ]),
          _createVNode(ValidationError, {
            name: "lastName",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('phone') }])
          }, [
            _createTextVNode("Phone Number "),
            _hoisted_14
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(quote).checkout.info.phone) = $event)),
            type: "tel",
            name: "phone",
            class: _normalizeClass({ validationfield: hasErrors('phone') }),
            onMaska: _cache[3] || (_cache[3] = ($event: any) => (phoneRaw.value = $event.target.dataset.maskRawValue)),
            onInput: validatedFieldChanged
          }, null, 34), [
            [_vModelText, _unref(quote).checkout.info.phone],
            [_directive_maska, ['(###) ###-####', '(###) ###-####']]
          ]),
          _createVNode(ValidationError, {
            name: "phone",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('dob') }])
          }, [
            _createTextVNode("Date of Birth "),
            _hoisted_16
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(quote).checkout.info.dob) = $event)),
            type: "date",
            style: {"padding":"0px"},
            max: _unref(minus18YearsDate),
            name: "dob",
            class: _normalizeClass({ validationfield: hasErrors('dob') }),
            onChange: validatedFieldChanged
          }, null, 42, _hoisted_17), [
            [_vModelText, _unref(quote).checkout.info.dob]
          ]),
          _createVNode(ValidationError, {
            name: "dob",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('email') }])
          }, [
            _createTextVNode("Email "),
            _hoisted_20
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(quote).checkout.info.email) = $event)),
            type: "text",
            name: "email",
            class: _normalizeClass({ validationfield: hasErrors('email') }),
            onInput: validatedFieldChanged
          }, null, 34), [
            [_vModelText, _unref(quote).checkout.info.email]
          ]),
          _createVNode(ValidationError, {
            name: "email",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _hoisted_21,
        _hoisted_22,
        _createElementVNode("p", null, [
          _withDirectives(_createElementVNode("input", {
            id: "emaildocs",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(quote).checkout.receiveByEmailConsent) = $event)),
            type: "checkbox",
            class: "styledchecked"
          }, null, 512), [
            [_vModelCheckbox, _unref(quote).checkout.receiveByEmailConsent]
          ]),
          _hoisted_23
        ]),
        _hoisted_24,
        _createElementVNode("p", null, [
          _createTextVNode(" By clicking \"Review Details\" below, I acknowledge that I have read, agreed, and understand this disclosure: "),
          _createElementVNode("a", {
            class: "javascriptlink",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (showConsentModal()))
          }, " Electronic Business Consent. ")
        ]),
        _hoisted_25,
        _hoisted_26,
        _hoisted_27,
        _hoisted_28,
        _hoisted_29,
        _hoisted_30,
        _hoisted_31,
        _createElementVNode("table", _hoisted_32, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quote).checkout.roommates, (roommate) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'roommate' + _unref(quote).checkout.roommates.indexOf(roommate),
                    class: "Additional-content-enty",
                    onClick: ($event: any) => (removeRoommate(roommate))
                  }, _toDisplayString(roommate.firstName) + " " + _toDisplayString(roommate.lastName), 9, _hoisted_36))
                }), 128))
              ]),
              _createElementVNode("td", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  id: "add-roommate-2",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((hasRoomate).value = $event)),
                  class: "additional-add",
                  disabled: hasRoomate.value,
                  type: "checkbox",
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (showAddRoomateModal()))
                }, null, 40, _hoisted_38), [
                  [_vModelCheckbox, hasRoomate.value]
                ]),
                _hoisted_39
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_40, [
                _hoisted_41,
                _hoisted_42,
                (hasInterestedParty.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "Additional-content-enty",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (removeInterestedParty(_unref(quote).checkout.interestedParty)))
                    }, _toDisplayString(_unref(quote).checkout.interestedParty.firstName) + " " + _toDisplayString(_unref(quote).checkout.interestedParty.lastName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  id: "3",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((hasInterestedParty).value = $event)),
                  class: "additional-add",
                  disabled: hasInterestedParty.value,
                  type: "checkbox",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (showInterestedPartyModal()))
                }, null, 40, _hoisted_44), [
                  [_vModelCheckbox, hasInterestedParty.value]
                ]),
                _hoisted_45
              ])
            ])
          ])
        ]),
        _hoisted_46,
        _createElementVNode("p", _hoisted_54, _toDisplayString(_unref(quote).address.formatted), 1),
        _hoisted_55,
        _hoisted_56,
        _createElementVNode("p", null, [
          _withDirectives(_createElementVNode("input", {
            id: "usesameadddress",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(quote).checkout.useSameAddressForMailing) = $event)),
            type: "checkbox",
            class: "styledchecked",
            "true-value": true
          }, null, 512), [
            [_vModelCheckbox, _unref(quote).checkout.useSameAddressForMailing]
          ]),
          _hoisted_57
        ]),
        _hoisted_58,
        (!_unref(quote).checkout.useSameAddressForMailing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('mailingAddress') }])
                }, [
                  _createTextVNode("Street Address "),
                  _hoisted_61
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(quote).checkout.mailingAddress.address) = $event)),
                  type: "text",
                  name: "mailingAddress",
                  class: _normalizeClass({ validationfield: hasErrors('mailingAddress') }),
                  onChange: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.mailingAddress.address]
                ]),
                _createVNode(ValidationError, {
                  name: "mailingAddress",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(quote).checkout.mailingAddress.apt) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, _unref(quote).checkout.mailingAddress.apt]
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('mailingCity') }])
                }, [
                  _createTextVNode("City "),
                  _hoisted_65
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(quote).checkout.mailingAddress.city) = $event)),
                  type: "text",
                  name: "mailingCity",
                  class: _normalizeClass({ validationfield: hasErrors('mailingCity') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.mailingAddress.city]
                ]),
                _createVNode(ValidationError, {
                  name: "mailingCity",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('mailingState') }])
                }, [
                  _createTextVNode("State "),
                  _hoisted_67
                ], 2),
                _createVNode(UsStatesBox, {
                  key: "mailing-state-box",
                  modelValue: _unref(quote).checkout.mailingAddress.state,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(quote).checkout.mailingAddress.state) = $event)),
                  initial: _unref(quote).checkout.mailingAddress.state,
                  "select-style": { validationfield: hasErrors('mailingState') },
                  name: "mailingState",
                  onChange: validatedFieldChanged
                }, null, 8, ["modelValue", "initial", "select-style"]),
                _createVNode(ValidationError, {
                  name: "mailingState",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('mailingZip') }])
                }, [
                  _createTextVNode("Zip "),
                  _hoisted_69
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(quote).checkout.mailingAddress.zip) = $event)),
                  type: "text",
                  name: "mailingZip",
                  class: _normalizeClass({ validationfield: hasErrors('mailingZip') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.mailingAddress.zip]
                ]),
                _createVNode(ValidationError, {
                  name: "mailingZip",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_70,
        _hoisted_71,
        _hoisted_72,
        (_unref(quote).hasPersonalInsurance)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_73,
              _hoisted_74,
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('schoolCity') }])
                }, [
                  _createTextVNode("School City "),
                  _hoisted_77
                ], 2),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(quote).checkout.schoolCity) = $event)),
                  name: "schoolCity",
                  class: _normalizeClass({ validationfield: hasErrors('schoolCity') }),
                  onChange: readNssiSchools
                }, [
                  _hoisted_78,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nssiSchoolCities.value, (city) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: city.key
                    }, _toDisplayString(city.Value), 1))
                  }), 128))
                ], 34), [
                  [_vModelSelect, _unref(quote).checkout.schoolCity]
                ]),
                _createVNode(ValidationError, {
                  name: "schoolCity",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('schoolName') }])
                }, [
                  _createTextVNode("School Name "),
                  _hoisted_80
                ], 2),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(quote).checkout.schoolKey) = $event)),
                  name: "schoolName",
                  class: _normalizeClass({ validationfield: hasErrors('schoolName') }),
                  disabled: schoolDisabled.value,
                  onChange: validatedFieldChanged
                }, [
                  _hoisted_82,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nssiSchoolsByCity.value, (school) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: school.Key,
                      value: school.Key
                    }, _toDisplayString(school.Value), 9, _hoisted_83))
                  }), 128))
                ], 42, _hoisted_81), [
                  [_vModelSelect, _unref(quote).checkout.schoolKey]
                ]),
                _createVNode(ValidationError, {
                  name: "schoolName",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _hoisted_84,
              _hoisted_85,
              _hoisted_86
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_87, "Payment Method", 512),
        _hoisted_88,
        _withDirectives(_createElementVNode("input", {
          id: "creditcard",
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(quote).checkout.paymentMethod.creditCard) = $event)),
          type: "radio",
          class: "styledradio",
          name: "paymentmethod",
          value: true,
          onChange: _cache[22] || (_cache[22] = ($event: any) => (_unref(quote).checkout.paymentMethod.creditCard = true))
        }, null, 544), [
          [_vModelRadio, _unref(quote).checkout.paymentMethod.creditCard]
        ]),
        _hoisted_89,
        _hoisted_90,
        _hoisted_91,
        (_unref(quote).checkout.paymentMethod.creditCard)
          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('nameOnCard') }])
                }, [
                  _createTextVNode("Name on Card "),
                  _hoisted_94
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(quote).checkout.paymentMethod.nameOnCard) = $event)),
                  type: "text",
                  name: "nameOnCard",
                  class: _normalizeClass({ validationfield: hasErrors('nameOnCard') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.nameOnCard]
                ]),
                _createVNode(ValidationError, {
                  name: "nameOnCard",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _hoisted_95,
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('cardNumber') }])
                }, [
                  _createTextVNode("Card Number "),
                  _hoisted_97
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(quote).checkout.paymentMethod.cardNumber) = $event)),
                  type: "text",
                  name: "cardNumber",
                  class: _normalizeClass({ validationfield: hasErrors('cardNumber') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.cardNumber],
                  [_directive_maska, { mask: '################' }]
                ]),
                _createVNode(ValidationError, {
                  name: "cardNumber",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("img", {
                  src: require('@/assets/images/creditcards-logo.png'),
                  width: "253",
                  height: "48",
                  alt: "Credit Cards Payment Method"
                }, null, 8, _hoisted_99)
              ]),
              _hoisted_100,
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('cvv') }])
                }, [
                  _createTextVNode("CVC "),
                  _hoisted_102
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(quote).checkout.paymentMethod.cvv) = $event)),
                  type: "text",
                  name: "cvv",
                  class: _normalizeClass({ validationfield: hasErrors('cvv') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.cvv],
                  [_directive_maska, { mask: '####' }]
                ]),
                _hoisted_103,
                _createVNode(ValidationError, {
                  name: "cvv",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('expDateMonth') }])
                }, [
                  _createTextVNode("Expiration Date "),
                  _hoisted_105
                ], 2),
                _createElementVNode("div", _hoisted_106, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(quote).checkout.paymentMethod.expDateMonth) = $event)),
                    class: _normalizeClass(["plainfieldselect", { validationfield: hasErrors('expDateMonth') }]),
                    placeholder: "Select Month",
                    name: "expDateMonth",
                    onChange: validatedFieldChanged
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardMonths.value, (month) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: month,
                        value: month
                      }, _toDisplayString(month), 9, _hoisted_107))
                    }), 128))
                  ], 34), [
                    [_vModelSelect, _unref(quote).checkout.paymentMethod.expDateMonth]
                  ]),
                  _createVNode(ValidationError, {
                    name: "expDateMonth",
                    errors: validationErrors.value
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(quote).checkout.paymentMethod.expDateYear) = $event)),
                    class: _normalizeClass(["plainfieldselect", { validationfield: hasErrors('expDateYear') }]),
                    placeholder: "Select Year",
                    name: "expDateYear",
                    onChange: validatedFieldChanged
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardYears.value, (year) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: year,
                        value: year
                      }, _toDisplayString(year), 9, _hoisted_109))
                    }), 128))
                  ], 34), [
                    [_vModelSelect, _unref(quote).checkout.paymentMethod.expDateYear]
                  ]),
                  _createVNode(ValidationError, {
                    name: "expDateYear",
                    errors: validationErrors.value
                  }, null, 8, ["errors"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_110,
        _hoisted_111,
        _hoisted_112,
        _createElementVNode("p", _hoisted_113, [
          (rentersNextPayment.value)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_114, _toDisplayString(rentersNextPayment.value), 1))
            : _createCommentVNode("", true),
          _hoisted_115,
          _hoisted_116,
          (nssiNextPayment.value)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_117, _toDisplayString(nssiNextPayment.value), 1))
            : _createCommentVNode("", true),
          _hoisted_118
        ]),
        _hoisted_119,
        _hoisted_120,
        _hoisted_121,
        _createElementVNode("div", _hoisted_122, [
          _withDirectives(_createElementVNode("input", {
            id: "billingaddress-property",
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddressType) = $event)),
            type: "radio",
            class: "styledradio",
            name: "billingaddress",
            checked: "",
            value: 1
          }, null, 512), [
            [_vModelRadio, _unref(quote).checkout.paymentMethod.billingAddressType]
          ]),
          _createElementVNode("label", _hoisted_123, [
            _createTextVNode("Use Property Address:"),
            _hoisted_124,
            _createVNode(_component_hint, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(quote).address.formatted), 1)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "billingaddress-mailing",
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddressType) = $event)),
            type: "radio",
            class: "styledradio",
            name: "billingaddress",
            value: 2
          }, null, 512), [
            [_vModelRadio, _unref(quote).checkout.paymentMethod.billingAddressType]
          ]),
          _createElementVNode("label", _hoisted_125, [
            _createTextVNode("Use Mailing Address:"),
            _hoisted_126,
            _createVNode(_component_hint, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(mailingAddress.value), 1)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            id: "billingaddress-different",
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddressType) = $event)),
            type: "radio",
            class: "styledradio",
            name: "billingaddress",
            value: 3
          }, null, 512), [
            [_vModelRadio, _unref(quote).checkout.paymentMethod.billingAddressType]
          ]),
          _hoisted_127
        ]),
        _hoisted_128,
        (_unref(quote).checkout.paymentMethod.billingAddressType == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
              _hoisted_130,
              _createElementVNode("div", _hoisted_131, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('billingFirstName') }])
                }, [
                  _createTextVNode("First Name "),
                  _hoisted_132
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddress.firstName) = $event)),
                  type: "text",
                  name: "billingFirstName",
                  class: _normalizeClass({ validationfield: hasErrors('billingFirstName') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.billingAddress.firstName]
                ]),
                _createVNode(ValidationError, {
                  name: "billingFirstName",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('billingLastName') }])
                }, [
                  _createTextVNode("Last Name "),
                  _hoisted_134
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddress.lastName) = $event)),
                  type: "text",
                  name: "billingLastName",
                  class: _normalizeClass({ validationfield: hasErrors('billingLastName') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.billingAddress.lastName]
                ]),
                _createVNode(ValidationError, {
                  name: "billingLastName",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('billingAddress') }])
                }, [
                  _createTextVNode("Street Address "),
                  _hoisted_136
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddress.address) = $event)),
                  type: "text",
                  name: "billingAddress",
                  class: _normalizeClass({ validationfield: hasErrors('billingAddress') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.billingAddress.address]
                ]),
                _createVNode(ValidationError, {
                  name: "billingAddress",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_137, [
                _hoisted_138,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddress.apt) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.billingAddress.apt]
                ])
              ]),
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('billingCity') }])
                }, [
                  _createTextVNode("City "),
                  _hoisted_140
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddress.city) = $event)),
                  type: "text",
                  name: "billingCity",
                  class: _normalizeClass({ validationfield: hasErrors('billingCity') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.billingAddress.city]
                ]),
                _createVNode(ValidationError, {
                  name: "billingCity",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_141, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('billingState') }])
                }, [
                  _createTextVNode("State "),
                  _hoisted_142
                ], 2),
                _createVNode(UsStatesBox, {
                  modelValue: _unref(quote).checkout.paymentMethod.billingAddress.state,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddress.state) = $event)),
                  initial: _unref(quote).checkout.paymentMethod.billingAddress.state,
                  name: "billingState",
                  "select-style": { validationfield: hasErrors('billingState') },
                  onChange: validatedFieldChanged
                }, null, 8, ["modelValue", "initial", "select-style"]),
                _createVNode(ValidationError, {
                  name: "billingState",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('billingZip') }])
                }, [
                  _createTextVNode("Zip "),
                  _hoisted_144
                ], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(quote).checkout.paymentMethod.billingAddress.zip) = $event)),
                  type: "text",
                  name: "billingZip",
                  class: _normalizeClass({ validationfield: hasErrors('billingZip') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, _unref(quote).checkout.paymentMethod.billingAddress.zip]
                ]),
                _createVNode(ValidationError, {
                  name: "billingZip",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_145,
        _hoisted_146,
        _hoisted_147,
        _createElementVNode("div", _hoisted_148, [
          _createElementVNode("button", {
            class: _normalizeClass({ disabled: !validated.value }),
            onClick: _cache[38] || (_cache[38] = ($event: any) => (goToPage('quote-review')))
          }, " Review Details ", 2)
        ]),
        _hoisted_149,
        _hoisted_150,
        _hoisted_151,
        _hoisted_152,
        _hoisted_153,
        _hoisted_154
      ]),
      _createVNode(QuoteCart)
    ]),
    _createVNode(BaseModal, { name: "electronicConsentModal" }, {
      default: _withCtx(() => [
        _createVNode(ElectronicConsentModal)
      ]),
      _: 1
    }),
    _createVNode(BaseModal, { name: "messageServiceModal" }, {
      default: _withCtx(() => [
        _createVNode(MessageServiceModal)
      ]),
      _: 1
    }),
    _createVNode(AddUserModal, { name: "addUserModal" }),
    _createVNode(AddInterestedPartyModal, { name: "addInterestedParty" })
  ]))
}
}

})